<div class="policy bg-light">
    <div class="policy__container" [style.height.px]="appAlert.windowHeight - 200">
        <div class="policy_header">
            <h1>DATENSCHUTZRICHTLINIE </h1>
            <h1>MOBILE APP EMODUL </h1>
        </div>
        <div class="row"></div>
        <div class="policy_navigation_menu">
            1.  <a class="link" (click)="appAlert.scrollTo('Introduction')">EINFÜHRUNG</a>
            <br />
            2.  <a class="link" (click)="appAlert.scrollTo('ContractDetails')">INFORMATIONEN ÜBER DEN ADMINISTRATOR VON EMODUL. KONTAKTDATEN</a>
            <br />
            3.  <a class="link" (click)="appAlert.scrollTo('AboutEModul')">WAS IST EMODUL</a>
            <br />
            4.  <a class="link" (click)="appAlert.scrollTo('AboutPolicy')">INFORMATIONEN ÜBER DIE RICHTLINIE</a>
            <br />
            5.  <a class="link" (click)="appAlert.scrollTo('DataCollection')">VON UNS ERFASSTE DATEN. ART DER DATENERFASSUNG</a>
            <br />
            6.  <a class="link" (click)="appAlert.scrollTo('DataUsage')">VERWENDUNG DER DATEN</a>
            <br />
            7.  <a class="link" (click)="appAlert.scrollTo('YourRights')">IHRE RECHTE IM ZUSAMMENHANG MIT DER DATENERFASSUNG</a>
            <br />
            8.  <a class="link" (click)="appAlert.scrollTo('StoringData')">AUFBEWAHRUNG VON DATEN </a>
            <br />
            9.  <a class="link" (click)="appAlert.scrollTo('SharingData')">BEREITSTELLUNG VON DATEN. ÜBERTRAGUNG VON DATEN IN DRITTLÄNDER</a>
        </div>
        <div class="policy_body>">
            <div class="policy_paragraph">
                <h1 id="Introduction">1. EINFÜHRUNG </h1>
                <p class="content">
                    Vielen Dank, dass Sie sich für die App eModul entschieden haben! Wir bemühen uns sicherzustellen, dass eModul alle Ihre Erwartungen erfüllt, deshalb gehören der
                    Schutz Ihrer Privatsphäre und die Sicherheit der Daten, die Sie uns zur Verfügung stellen, zu unseren obersten Prioritäten. Um dies zu gewährleisten, haben wir
                    ein Dokument erstellt, das wir als Datenschutzrichtlinie für die Mobile App eModul bezeichnen. Wir bitten Sie, die Richtlinie vor der Verwendung von eModul gründlich
                    zu lesen.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="ContractDetails">2. INFORMATIONEN ÜBER DEN ADMINISTRATOR VON EMODUL. KONTAKTDATEN </h1>
                <p class="content">
                    eModul ist eine Anwendung, die durch TECH STEROWNIKI Gesellschaft mit begrenzter Haftung Kommanditgesellschaft mit Sitz in Wieprz, Ul. Biała Droga 31, 34-122 Wieprz,
                    Polen, NIP 551 23 60 632, REGON 356782780, KRS 0000594881 erstellt und administriert wird. Wir empfehlen Ihnen, uns in allen für Sie wichtigen Angelegenheiten zu
                    kontaktieren. Sie erreichen uns unter:
                </p>
                <table class="policy_contact_details_table">
                    <tr>
                        <td>e-mail</td>
                        <td>poczta&#64;techsterowniki.pl </td>
                    </tr>
                    <tr class="separating_line">
                        <td>Postalisch </td>
                        <td>ul. Biała Droga 31, 34-122 Wieprz, Polen </td>
                    </tr>
                    <tr class="separating_line">
                        <td>Telefonisch  </td>
                        <td>+48 33 330 00 07 </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutEModul">3. WAS IST EMODUL  </h1>
                <p class="content">
                    eModul ist eine Anwendung zur Unterstützung von Steuergeräten, die mit Modulen der Serie ST-505 und Wi-Fi zusammenarbeiten. Mit eModul können Sie:
                </p>
                <ul class="pp_list">
                    <li>eine Vorschau aller aktuellen Parameter des Steuergeräts einsehen sowie diese Parameter bearbeiten; </li>
                    <li>eine Vorschau der Temperatur-  und Alarmhistorie einsehen; </li>
                    <li>viele Module von einem Konto aus steuern; und zudem </li>
                    <li>eine E-Mail-Benachrichtigung über aktuelle Alarme erhalten. </li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    Die Nutzung von eModul ist kostenlos, erfordert jedoch die Zusammenarbeit der Steuergeräte mit den oben genannten Modulen. Alle Daten, die Sie uns zur Verfügung stellen,
                    sind für das reibungslose Funktionieren von eModul notwendige Daten, Daten für statistische Zwecke sowie Daten, die im Zusammenhang mit der Verbesserung der
                    Funktionsweise von eModul eingesetzt werden. eModul ist für Personen im Alter von über 13 Jahren gedacht
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutPolicy">4. INFORMATIONEN ÜBER DIE RICHTLINIE</h1>
                <p class="content">
                    Die Richtlinie enthält alle notwendigen Informationen, die unsere Beziehungen zu den von Ihnen bereitgestellten Informationen regeln. Das grundlegende Ziel der Richtlinie ist es daher sicherzustellen, dass:
                </p>
                <ul class="pp_list">
                    <li>Sie in jeder Phase unserer Zusammenarbeit wissen, welche Daten wir von Ihnen erheben, was wir damit machen und welche Rechte Sie in dieser Hinsicht haben; </li>
                    <li>Ihre Zustimmung zur Übermittlung von Daten an uns stets bewusst und freiwillig erfolgt</li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    Wir entwickeln und verbessern eModul ständig. Wenn wir daher Änderungen an der Anwendung vornehmen, die sich auf den Umfang der Erfassung und Verarbeitung der von
                    Ihnen bereitgestellten Daten auswirken, werden wir Ihnen zusätzliche Informationen, Bedingungen oder Grundsätze mitteilen. Wenn der neue Umfang der Erfassung und
                    Verarbeitung nicht Ihren Präferenzen entsprechen sollte, können Sie ihm jederzeit widersprechen, allerdings kann dies zum Abschalten von eModul auf Ihrem Gerät führen.
                </p>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    Auch wenn es zu keinen Änderungen in eModul kommt, können wir die Richtlinie in regelmäßigen Abständen selbst ändern. Im Falle solcher Änderungen werden
                    wir Sie darüber klar und unmissverständlich informieren (z. B. per E-Mail). Jegliche Änderungen der Richtlinie treten zu einem Zeitpunkt in Kraft, der es
                    Ihnen erlaubt, frei darüber zu entscheiden, ob Sie eModul trotz der vorgenommenen Änderungen weiterhin nutzen möchten.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataCollection">5. VON UNS ERFASSTE DATEN. ART DER DATENERFASSUNG </h1>
                <p class="content">
                    Im Folgenden haben wir die Daten aufgelistet, die wir in jeder Phase der Interaktion mit eModul von Ihnen erheben:
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Phase  </th>
                        <th>Kategorie  </th>
                        <th>Beschreibung  </th>
                    </tr>

                    <tr>
                        <td>Registrierung   </td>
                        <td>Registrierungsdaten  </td>
                        <td>
                            <p>Dies sind alle Daten, die Sie uns bei der Registrierung in eModul zur Verfügung stellen. Die Bedingung für ihre Erfassung ist, dass Sie sie freiwillig in eModul eingeben</p>
                            <p>Die Daten, die wir in dieser Phase von Ihnen erfassen, umfassen: eine E-Mail-Adresse, um die Kontoregistrierung überprüfen zu können</p>
                        </td>
                    </tr>

                    <tr>
                        <td>Registrierung des Moduls </td>
                        <td>Detaillierte Registrierungsdaten </td>
                        <td>
                            <p>Dies sind alle Daten, die Sie uns bei der Registrierung des erworbenen Moduls mitteilen. Die Bedingung für ihre Sammlung ist, dass Sie sie freiwillig in eModul eingeben. </p>
                            <p>Die Daten, die wir in dieser Phase von Ihnen erheben, umfassen: eine E-Mail-Adresse für das Senden von Benachrichtigungen (dies kann die gleiche Adresse wie jene für die Registrierung sein), Telefonnummer für das Senden von Benachrichtigungen.</p>
                            <p>Während des Registrierungsprozesses des Moduls können Sie uns zusätzliche Informationen zur Verfügung stellen, um Ihr Konto eModul stärker zu personalisieren. Insbesondere bitten wir Sie um die Angabe von Postleitzahl und Land, wobei
                                die Angabe dieser Daten für den Abschluss der detaillierten Anmeldung nicht erforderlich ist. </p>
                        </td>
                    </tr>
                    <tr>
                        <td>Nutzung von eModul</td>
                        <td>Nutzungsdaten  </td>
                        <td>
                            <p>Dies sind alle Daten, die wir von Ihnen in automatisierter Weise erfassen, während Sie eModul verwenden. </p>
                            <p>Daten, die wir von Ihnen in dieser Phase erheben, umfassen: Name des Geräts, einzigartiger Geräte-Token (für die Zwecke von Benachrichtigungen), SoftwareVersion des Geräts, Land der Installierung von eModul
                                sowie Informationen über alle von eModul eventuell verursachten Fehlern/</p>
                            <p>eModul in der Browser-Version verwendet auch Cookies, die ausschließlich zum Zweck der Aufrechterhaltung der Anmeldung (Sitzung) verwendet werden. </p>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    Alle von uns erhobenen Daten, die Sie bei der Modulregistrierung angeben, werden freiwillig zur Verfügung gestellt. Die automatisch gesammelten Daten ermöglichen uns die Verbesserung von eModul.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataUsage">6. VERWENDUNG DER DATEN</h1>
                <p class="content">
                    Im Folgenden haben wir angegeben, wie wir die von Ihnen gesammelten Daten verwenden.
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Kategorie  </th>
                        <th>Grundlage   </th>
                        <th>Verarbeitungsgründe </th>
                    </tr>

                    <tr>
                        <td>Registrierungsdaten </td>
                        <td>Vertragsdurchführung </td>
                        <td>
                            Diese Daten sind für die Durchführung des mit Ihnen abgeschlossenen Vertrages sowie Ihre Anmeldung über eModul erforderlich.
                            Dieser Vertrag betrifft die Erstellung eines Kontos in eModul, in dem das Steuergerät registriert werden kann.
                        </td>
                    </tr>
                    <tr>
                        <td>Detaillierte Registrierungsdaten </td>
                        <td>Vertragsdurchführung  </td>
                        <td>
                            Diese Daten sind für die Durchführung des mit Ihnen abgeschlossenen Vertrages sowie Ihre Anmeldung über eModul erforderlich. Diese Vereinbarung betrifft die
                            Verfügbarkeit der in Abschnitt 3 der Richtlinie beschriebenen Funktionalitäten von eModul.
                        </td>
                    </tr>
                    <tr>
                        <td>Detaillierte Registrierungsdaten</td>
                        <td>Vertragsdurchführung </td>
                        <td>
                            Diese Daten sind notwendig, um mit Ihnen in Verbindung mit in den Modulen auftretenden Alarmen zu kommunizieren.
                        </td>
                    </tr>

                    <tr>
                        <td>Detaillierte Registrierungsdaten</td>
                        <td>Ihre Einwilligung </td>
                        <td>
                            Bei der detaillierten Registrierung können Sie uns zusätzliche Daten zur Verfügung stellen, einschließlich Postleitzahl und Land. Wir verwenden diese Daten zu statistischen Zwecken und zu Zwecken,
                            die mit der Verbesserung des Funktionierens von eModul zusammenhängen.
                        </td>
                    </tr>

                    <tr>
                        <td>Nutzungsdaten </td>
                        <td>Vertragsdurchführung  <br/> <br/> Berechtigte Interessen</td>
                        <td>
                            Wir verwenden diese Daten zu statistischen Zwecken und zu Zwecken, die mit der Verbesserung des Funktionierens von eModul zusammenhängen.
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    WeWir verwenden die von Ihnen erhaltenen Daten niemals zum Treffen automatischer Entscheidungen, einschließlich Profiling, wenn die jeweilige Entscheidung für Sie Rechtsfolgen oder ähnliche Auswirkungen haben kann.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="YourRights">7. IHRE RECHTE IM ZUSAMMENHANG MIT DER DATENERFASSUNG </h1>
                <p class="content">
                    Aufgrund der Tatsache, dass Sie uns Ihre Daten einschließlich personenbezogener Daten zur Verfügung stellen, stehen Ihnen eine Reihe von Rechten zu. Denken Sie daher daran, dass Sie jederzeit zu folgendem berechtigt sind:
                </p>
                <table class="policy_details_table_no_header">
                    <tr>
                        <td>Auskunftsrecht  </td>
                        <td>Recht auf Information über und Zugang zu den von uns verarbeiteten Daten</td>
                    </tr>
                    <tr>
                        <td>Recht auf Berichtigung </td>
                        <td>Recht, die Korrektur oder Aktualisierung von Daten zu verlangen, wenn sie ungenau oder unvollständig sind. </td>
                    </tr>
                    <tr>
                        <td>Recht auf Löschung   </td>
                        <td>Recht, die Löschung von Daten zu verlangen. </td>
                    </tr>

                    <tr>
                        <td>Recht auf Einschränkung  </td>
                        <td>Recht zu verlangen, dass wir alle oder einen Teil der Daten vorübergehend oder dauerhaft nicht mehr verarbeiten</td>
                    </tr>

                    <tr>
                        <td>Recht auf Widerspruch </td>
                        <td>Recht, die von uns vorgenommene Verarbeitung von Daten aus Gründen, die mit bestimmten Situationen zusammenhängen, jederzeit zu widerrufen. </td>
                    </tr>
                    <tr>
                        <td>Recht auf Datenübertragbarkeit </td>
                        <td>Recht, eine elektronische Kopie der Daten anzufordern oder zur Nutzung durch Dritte zu übertragen. </td>
                    </tr>
                    <tr>
                        <td>Beschwerderecht </td>
                        <td>Recht, eine Beschwerde über die Verarbeitung personenbezogener Daten bei der Aufsichtsbehörde einzureichen, die in Polen der Präsident des Amtes für den Schutz personenbezogener Daten ist. </td>
                    </tr>
                </table>
                <p>
                    Sie können alle Ihnen zustehenden Rechte ausüben, indem Sie sich mit uns gemäß den in Abschnitt 2 der Richtlinie angegebenen Kontaktdaten in Verbindung setzen.
                </p>
            </div>
            <div class="policy_paragraph">
                <h1 id="StoringData">8. AUFBEWAHRUNG VON DATEN  </h1>
                <p class="content">
                    Wir speichern Ihre Daten, die wir im Zusammenhang mit dem Vertrag und aufgrund eines berechtigten Interesses verarbeiten, solange dies dafür notwendig ist, um Ihnen
                    die Nutzung von eModul zu gewährleisten, sowie für legitime und notwendige Zwecke, die Erfüllung gesetzlicher Verpflichtungen und das Lösen von Konflikten.
                    Ihre Daten werden so lange gespeichert, wie Sie eModul verwenden, worunter wir das Eintreten der Situation verstehen, in der Sie uns Ihren Wunsch zur Löschung Ihres
                    Konto mitteilen. Sobald Sie eModul nicht mehr verwenden, werden Ihre Daten noch während der Verjährungsfrist für etwaige Ansprüche von uns gespeichert.
                </p>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    Wir speichern Ihre Daten, die wir aufgrund Ihrer Einwilligung verarbeiten, solange Sie Ihre Einwilligung nicht widerrufen. Um Ihre Einwilligung zu widerrufen, verwenden Sie
                    einfach die entsprechende Funktion von eModul oder melden Sie uns Ihre Absicht zur Löschung Ihres Kontos.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="SharingData">9. BEREITSTELLUNG VON DATEN. ÜBERTRAGUNG VON DATEN IN DRITTLÄNDER </h1>
                <p class="content">
                    Ihre Daten dürfen nur in Situationen weitergegeben werden, in denen das Gesetz dies zulässt. Momentan beabsichtigen wir, diese Daten ausschließlich auf der Grundlage eines Vertrages zur Übertragung der Verarbeitung an folgende Subjekte weiterzugeben:
                </p>
                <ul class="pp_list">
                    <li>Unterstützung von IT-Infrastruktur und Informationssystemen; </li>
                    <li>Subunternehmer, die uns dabei helfen, unsere Verpflichtungen ordnungsgemäß zu erfüllen. </li>
                </ul>
            </div>
            <div class="policy_paragraph">
                <p class="content">
                    Ihre Daten werden nicht in Länder außerhalb des Europäischen Wirtschaftsraums gesendet.
                </p>
            </div>
        </div>
    </div>
    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>
</div>
